import { render, staticRenderFns } from "./ComplaintChannel.vue?vue&type=template&id=1a34d153&"
import script from "./ComplaintChannel.vue?vue&type=script&lang=js&"
export * from "./ComplaintChannel.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintChannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports